export const gicPersistentStatePreferenceKey = 'jira.user.gic.persistent.modal.view.state' as const;
